// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"104":"9b030e85","660":"9b5612a2"}[chunkId] + ".js";
};